import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchList, fetchDelete, fetchDeptTree } from '@/api/system/dept/dept';
import waves from '@/directive/waves'; // 水波纹指令

import deptAdd from './add';
export default {
  name: 'ComplexTable',
  components: {
    deptAdd: deptAdd
  },
  directives: {
    waves: waves
  },
  data: function data() {
    return {
      options: [],
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        deptName: '',
        upDeptId: ''
      },
      propstree: {
        label: 'deptName',
        value: 'deptId',
        children: 'childDept'
      },
      title: '',
      deptId: -1,
      upDeptId: [],
      multipleSelection: [],
      dialogFormVisible: false
    };
  },
  created: function created() {
    this.getList();
    this.loadDeptTree();
  },
  methods: {
    loadDeptTree: function loadDeptTree() {
      var _this = this;

      var treeQuery = {};
      fetchDeptTree(treeQuery).then(function (response) {
        _this.options = response.data.data;
      });
    },
    handCancle: function handCancle(reload) {
      if (reload) {
        this.getList();
        this.loadDeptTree();
      }

      this.dialogFormVisible = false;
    },
    getList: function getList() {
      var _this2 = this;

      this.listLoading = true;

      if (this.upDeptId.length > 0) {
        this.listQuery.upDeptId = this.upDeptId[this.upDeptId.length - 1];
      } else {
        this.listQuery.upDeptId = '';
      }

      fetchList(this.listQuery).then(function (response) {
        _this2.list = response.data.data;
        _this2.total = response.data.total;
        _this2.listLoading = false;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 创建
    handleCreate: function handleCreate() {
      this.deptId = '-1';
      this.title = '创建';
      this.dialogFormVisible = true;
    },
    // 编辑
    handleUpdate: function handleUpdate(deptId) {
      this.deptId = deptId;
      this.title = '编辑';
      this.dialogFormVisible = true;
    },
    delete: function _delete(deptIds) {
      var _this3 = this;

      if (deptIds.length > 0) {
        this.$confirm('你确定是要删除这些记录, 是否继续?', '提示').then(function () {
          fetchDelete(deptIds).then(function (response) {
            if (response.data.code == 200) {
              _this3.getList();

              _this3.loadDeptTree();

              _this3.Alert({
                alertType: 'delete'
              });
            } else {
              _this3.Alert({
                alertType: 'error',
                message: response.data.message
              });
            }
          });
        });
      } else {
        this.Alert({
          alertType: 'nodata'
        });
      }
    },
    handleDelete: function handleDelete(deptId) {
      var deptIds = [];
      deptIds.push(deptId);
      this.delete(deptIds);
    },
    handleDeletes: function handleDeletes() {
      var deptIds = [];
      this.multipleSelection.forEach(function (row) {
        deptIds.push(row.deptId);
      });
      this.delete(deptIds);
    }
  }
};